module.exports = __webpack_public_path__ + "img/open_barrier.c736558c.svg";